import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import PhoneNumberInput from "components/PhoneNumberInput";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { CHANGE_PHONE_NUMBER } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import ModalVerification from "screens/ModalVerification";

const ModalNewPhoneNumber = ({
  hidden,
  isOpen,
  setIsOpen,
  refetch,
  token
}) => {

  const [verificationIsOpen, setVerificationIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("")
  const [phoneNumberValidity, setPhoneNumberValidity] = useState(true);
  const [phoneNumberError, setPhoneNumberError] = useState(false);

  const [changePhoneNumber, { loading, error }] = useMutation(CHANGE_PHONE_NUMBER, {
    onCompleted: (data) => {
      setVerificationIsOpen(true);
      setFailedIsOpen(false);
      setPhoneNumber("");
    },
    onError: (error) => {
      setVerificationIsOpen(false);
      setFailedIsOpen(true);
    }
  });

  const handleContinue = () => {
    if (!(phoneNumberValidity && phoneNumber.length > 0)) {
      setPhoneNumberError(true);
      return;
    }
    changePhoneNumber({
      variables: {
        input: {
          phoneNumber: phoneNumber,
          token: token
        }
      }
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          Enter New Email Address
        </Head>
        <Container>
          <PhoneNumberInput
            title="PHONE NUMBER"
            required
            error={phoneNumberError}
            value={phoneNumber}
            onChangeNumber={setPhoneNumber}
            onPhoneValidityChange={setPhoneNumberValidity}
            onBlur={() => {          
              setPhoneNumberError(!phoneNumberValidity && phoneNumber.length > 0);
            }}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalVerification
        isOpen={verificationIsOpen}
        setIsOpen={setVerificationIsOpen}
        refetch={refetch}
        phoneNumber={phoneNumber}
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setClose={()=> {
          setPhoneNumber("");
          setFailedIsOpen(false);
        }}
        loading={loading}
        errorMessage={error?.message || "Failed to change phone number. Please try again."}
        retryFunction={handleContinue}
        type="changePhoneNumber"
      />
    </>
  );
};

export default ModalNewPhoneNumber;